<!-- <div class="display-table-container">
  <table id="displayTable">
    <thead>
      <tr>
        <ng-container *ngFor="let column of headers | keyvalue:originalOrder">
          <th class="py-5 px-2">{{column.value}}</th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
        <tr *ngFor="let row of rows, let i=index" id="tab{{i}}">
          <td class="p-2" *ngFor="let column of headers | keyvalue:originalOrder, let j=index" id="cell{{i}}{{j}}">{{row[column.key]}}</td>
        </tr>
    </tbody>
  </table>
</div>  -->

<div class="display-table-container">
  <table id="displayTable">
    <thead>
      <tr>
        <ng-container *ngFor="let column of headers | keyvalue:originalOrder">
          <th class="py-5 px-2">{{column.value}}</th>
        </ng-container>
      </tr>
    </thead>
  </table>

  <cdk-virtual-scroll-viewport class="detail-container" itemSize="10" minBufferPx="200" maxBufferPx="400">
    <table>
      <tbody>
          <tr *cdkVirtualFor="let row of rows, let i=index" id="tab{{i}}">
            <td class="p-2" *ngFor="let column of headers | keyvalue:originalOrder, let j=index" id="cell{{i}}{{j}}">{{row[column.key]}}</td>
          </tr>
      </tbody>
    </table>
  </cdk-virtual-scroll-viewport>
</div> 


<!-- <div class="display-table-container">
  <div class="table" id="displayTable">
    <div class="head">
      <div class="tr">
        <ng-container *ngFor="let column of headers | keyvalue:originalOrder">
          <div class="py-5 px-2 th">{{column.value}}</div>
        </ng-container>
      </div>
    </div>
    <div class="tbody">
      <cdk-virtual-scroll-viewport class="detail-container" itemSize="10" minBufferPx="200" maxBufferPx="400">
        <div class="tr" *cdkVirtualFor="let row of rows, let i=index" id="tab{{i}}">
          <div class="p-2 td" *ngFor="let column of headers | keyvalue:originalOrder, let j=index" id="cell{{i}}{{j}}">{{row[column.key]}}</div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
</div>  -->
